
import Vue from 'vue'
import VueAxios from 'vue-axios'
import { securedAxiosInstance, plainAxiosInstance } from './axios'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins'

console.log(process.env.NODE_ENV)

Vue.config.productionTip = false

Vue.use(VueAxios, {
  secured: securedAxiosInstance,
  plain: plainAxiosInstance,
})

new Vue({
  router,
  vuetify,
  securedAxiosInstance,
  plainAxiosInstance,
  render: h => h(App),
}).$mount('#app')
